

<img src="images/banner.png" alt="" style="width: 100%; height: 200px;">

<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <div class="container-fluid">
    <a class="navbar-brand">
      <img src="images/logo.png" alt="" width="150" height="40" class="d-inline-block align-text-top">
    </a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor02" aria-controls="navbarColor02" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarColor02">
      <ul class="navbar-nav me-auto mt-3 mb-lg-0" >
        <li class="nav-item">
          <a class="nav-link text-light">Programa Nacional de Aprendizaje</a>
        </li>
      </ul>
      <div class="d-flex account ">
        <a *ngIf="!user" class="nav-link justify-content-center d-flex align-items-center" (click)="login()" id="navbarDropdownMenuLink" role="button" aria-haspopup="true" aria-expanded="false">
          <img src="img/login.png" alt="" width="25" height="25" class="d-inline-block align-text-top">
          Iniciar sesión
        </a>
        <div class="dropdown">
          <!--a *ngIf="loggedIn" class="nav-link dropdown-toggle d-flex align-items-center" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"-->
          <a *ngIf="user" class="nav-link dropdown-toggle d-flex align-items-center" href="#" id="ver" role="button" data-bs-toggle="dropdown" aria-expanded="false">
            <img src="img/login.png" alt="" width="25" height="25" class="d-inline-block align-text-top">
            {{user.nombres}} {{user.apellidos}}  |  <div class="ml5" *ngIf="user.id_institucional"> {{user.rol.nombre}}</div>
          </a>
          <ul class="dropdown-menu" aria-labelledby="ver">
            <li><a class="dropdown-item" style="cursor: pointer;">Cambiar contraseña</a></li>
            <li><a class="dropdown-item" style="cursor: pointer;" (click)="cerrarSesion()">Cerrar sesión</a></li>
            <!--a class="dropdown-item" (click)="openModal()">Cerrar sesión</a-->
          </ul>
        </div>

      </div>
    </div>
  </div>
</nav>



<!--button class="btn btn-outline-primary mb-2 me-2" (click)="alerta(content)">
	Modal vertically centered
</button>
<ng-template #content let-modal>
	<div class="modal-header">
		<h4 class="modal-title">Modal title</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<p>One fine body&hellip;</p>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Close</button>
	</div>
</ng-template-->

